const ToolsPage : React.FC = () => {
    return (
        <div className="toolsPage">
            
            <div className="tools">

                <div className="toolCard">
                    <div className="toolHeader">
                        <div className="title">
                            Export Likes
                        </div>
                        <div className="about">About ICO</div>
                    </div>
                    
                </div>
            </div>
        </div>
    )
}

export default ToolsPage;